//Admin/ReportCriteria/Set/{AuthToken}/
import React from 'react'
import { useSelector, useDispatch } from "react-redux";
import { reportcriteriaModify, selectReportCriteriaEntities } from '../../../reducers/admincenter_reportcriteria';
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectAdminGroupCascaded, selectAdminGroupDirect, selectAdminGroups, selectAdminGroupsWithoutParents } from '../../../reducers/admincenter_groups';
import _ from "lodash"
import DropdownTreeSelect from 'react-dropdown-tree-select'


/**
 * 
{
"ReportCriteria":
{
"ReportGuid": "97069626-6A92-4BA5-AC4B-B47969B454D9",
"SelectedAssessmentProduct": "HRA200",
"ParticipantGuid": "5FEA08D8-4F8B-4CF8-957A-2EC1FE8B36ED",
"AssessmentGuid": "C83D7CEE-1870-467B-953A-E414006D5C57",
"ReportOutputFormat": "XML",
"FirstRowHeader": "1",
"ReportGroupName": "Arbitrary Name Passed By Caller",
"IncludeAdditionalQuestions": "1",
"ExcludeInactiveParticipants": "0",
"DateRangeStart": "2015-01-01",
"DateRangeEnd": "2016-12-31",
"HRAStartedInDateRange": "0",
"HRANotStartedInDateRange": "0",
"HRACompletedInDateRange": "1",
"HRANotCompletedInDateRange": "0",
"GroupGuidList":["6C096600-B754-49A0-A72D-23CC85548FC7","032AAA24-4222-4FD2-AC42-2F690FCCE860","6F8E2BCC-AC19-4353-B245-A6F74DE7F7E1","45642721-13D9-4A15-9220-F8B4CF11B3A6","5DED27D7-D094-4295-800F-3CE85B3B4AF5","9EE86F41-5A96-4984-A4BE-DD93FD893B7A","5E4AB781-A30A-4D47-9751-C0D453505AEF","4C1C8A83-F70F-44A4-BEDB-966D16389367","D7D6843F-DD37-4464-9B75-22D872304B24","0CD7527D-5D34-4176-AACE-F404BF825FFF"]
}'
 */
import "../../../styles/treeselect.css"
import { contextUpsert, selectContextEntities } from '../../../reducers/global_contexts';
const ReportCriteriaGroupSelect = (props) => {
    const dispatch = useDispatch()
    // to reuse this componment in report criteria and participant move, i added a prop for the location
    // this should conditionally influence the store.
    const SelectLocation = props.SelectLocation
    const { user: currentUser } = useSelector((state) => state.auth);
    const authState = useSelector((state) => state.auth);

    const parentGroups = useSelector(state => selectAdminGroupsWithoutParents(state))
    const directRelationships = useSelector(state => selectAdminGroupDirect(state))
    const allGroups = useSelector(state => selectAdminGroups(state))
    const cascadedRelationships = useSelector(state => selectAdminGroupCascaded(state))
    const ReportCriteria = useSelector(state => selectReportCriteriaEntities(state))
    const Contexts = useSelector(state=> selectContextEntities(state))
    const {participantMoveGroupGuid} = Contexts


    const onChange = (currentNode, selectedNodes) => {
        const GroupArray = []
        if (SelectLocation === "REPORT CRITERIA") {
            for (var i = 0; i < selectedNodes.length; i++) {

                if (selectedNodes[i]._children.length > 0) {
                    let childrens = cascadedRelationships.filter((y) => { return y.OrganizationId_Guid_Parent === selectedNodes[i].value })

                    for (var h = 0; h < childrens.length; h++) {
                        GroupArray.push(childrens[h].OrganizationId_Guid_Child)
                    }
                }
                GroupArray.push(selectedNodes[i].value)
            }

            dispatch(reportcriteriaModify({ Key: 'GroupGuidList', Value: GroupArray }))
        }

        if (SelectLocation === "PARTICIPANT MOVE"){
   
            dispatch(contextUpsert({Key:"participantMoveGroupGuid", Value:currentNode.value}))
        }
    }

    const dataFormated = (OrganizationId_Guid) => {
        const index = allGroups.map(e => e.OrganizationId_Guid).indexOf(OrganizationId_Guid)
        const Org = allGroups[index]
        return {
            label: Org.OrganizationName
            , value: Org.OrganizationId_Guid
            , checked: (
                    ReportCriteria.GroupGuidList.indexOf(Org.OrganizationId_Guid) >= 0 && SelectLocation === "REPORT CRITERIA"
                    ) || (
                        participantMoveGroupGuid === Org.OrganizationId_Guid && SelectLocation === "PARTICIPANT MOVE"
                    )
            , expanded: true
            , children: directRelationships.filter((x) => {
                return x.OrganizationId_Guid_Parent === OrganizationId_Guid
            }
            ).map((m) => { return dataFormated(m.OrganizationId_Guid_Child) })
        }
    }
    const data = parentGroups.map(x => dataFormated(x.OrganizationId_Guid))
    return (
        <DropdownTreeSelect
            data={data}
            onChange={onChange}
            //onAction={onAction} 
            //onNodeToggle={onNodeToggle}  
            className="mdl-demo"
            texts={{ placeholder: "Select Groups" }}
            keepChildrenOnSearch={true}
            keepTreeOnSearch={true}
            showDropdown="always"
        />
    )

}
export default ReportCriteriaGroupSelect
